// Test IDs for the site-wide password gate (see ./index.js for the recipe).

export const SITE_GATE = {
	overlay: 'site-gate-overlay',
	passwordInput: 'site-gate-password-input',
	submitButton: 'site-gate-submit-button',
	error: 'site-gate-error',
};
